import { TInvitationNotificationItem } from "../../services/jobInvitation"
import { ENotificationTypes, TNotificationItem } from "../../types"
import { TAppState } from "../types"

interface IMapJobInvitationReducer {
    state: TAppState
    jobInvitations: TInvitationNotificationItem[]
}

export const mapJobInvitationNotificationReducer = (params: IMapJobInvitationReducer) => {
    const { state, jobInvitations } = params

    const jobInvitationNotifications: TNotificationItem[] = jobInvitations.map((item) => ({
        notifyKey: `JI-${item.id}-${item.jobId}`,
        companyLogo: item.companyLogo ?? '',
        companyName: item.companyName ?? '',
        employerId: -1,
        isAttached: -1,
        isRead: item.status,
        isShowLogo: 1,
        noOfEmployerViews: 0,
        resumeId: -1,
        sentDate: item.time,
        source: -1,
        statusId: "-1",
        type: ENotificationTypes.JOB_INVITATION,
        userId: -1,
        jobInvitationId: item.id,
        viewDate: item.time,
        jobTitle: item.jobTitle ?? '',
        expiredDate: 0,
        aliasEn: '',
        aliasVi: '',
        alias: item.alias ?? '',
        content: item.content ?? ''
    }))

    return { ...state, jobInvitationNotifications: jobInvitationNotifications }
}
